import styled from 'styled-components';

import CommonTooltip from './CommonTooltip';

const BarTooltip = styled(CommonTooltip)`
  &::before,
  &::after {
    display: none; /* Explicitly hide the arrows */
  }
`;

export default BarTooltip;
